import { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import {
  ShortcutUpsertContextProps,
  TtzkPortalShortcutUpsertService,
} from "../../../../application/service/ttzk-portal/ttzk-portal-upsert-service";

import { useAuthContextV2 } from "../../../../auth-state";
import ShortcutForm from "../../../organisms/ttzk-portal/shortcut-form";
import { PortalTemplate } from "../../../template/portal/default-template";
import { TtzkPortalR } from "../route";

const ShortcutCreate: React.FC<ShortcutUpsertContextProps> = ({
  onSave,
  onChange,
  shortcut,
  onFileAttached,
  setOrganization,
  isUpdating,
}) => {
  const { auth } = useAuthContextV2();
  const orgId = auth.data?.orgId;

  useEffect(() => {
    if (
      orgId &&
      typeof orgId === "string" &&
      shortcut.organizationId !== orgId
    ) {
      onChange({
        ...shortcut,
        organizationId: orgId,
      });
    }
  }, [onChange, orgId, shortcut]);

  if (!auth.hasPermissions("ttzk_portal.shortcuts.create")) {
    return <Redirect to={TtzkPortalR.Home.link({})} />;
  }
  return (
    <PortalTemplate
      breadcrumbs={[
        { to: TtzkPortalR.Home.link({}), title: "Graffer ポータル" },
        { to: TtzkPortalR.ShortcutList.link({}), title: "ショートカット一覧" },
        { to: TtzkPortalR.ShortcutCreate.link({}), title: "新規作成" },
      ]}
    >
      <ShortcutForm
        onChange={onChange}
        onSave={onSave}
        shortcut={shortcut}
        onFileAttached={onFileAttached}
        setOrganization={setOrganization}
        isUpdating={isUpdating}
      />
    </PortalTemplate>
  );
};

export const ShortcutCreateContainer = connectPageService(
  ShortcutCreate,
  () => new TtzkPortalShortcutUpsertService(),
);
